<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

      <p v-if="clicks.length == 0" class="pt-3 text-center">No clicks</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table mt-3">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Product</th>
                  <th class="pl-3">Total clicks</th>
                  <th class="first-right px-3">Unique clicks</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(click, index) in clicks" :key="index.id">
              
              <td class="pl-3">
                <a v-if="click.product" :href="`/product/${click.product.id}/click`" target="_blank">{{click.product.name}}</a>
                <div v-else>Product not found</div>
              </td>
              <td class="pl-3">{{click.total_clicks}}</td>
              <td class="pl-3">{{click.unique_clicks}}</td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Product • Clicks • Unique</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(click, index) in clicks" :key="index">
  
        <td class="pl-2">
            <div>
              <a v-if="click.product" :href="`/product/${click.product.id}/click`" target="_blank">{{click.product.name}}</a>
              <div v-else>Product not found</div>
              </div>
            <div>Total: {{ click.total_clicks }}</div>
            <div>Unique: {{ click.unique_clicks }}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>
export default {
  data() {
    return {
      clicks: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getClicks();

    // Echo.private("clicks")
    //   .listen("NewClick", (event) => {
    //     this.getClicks();
    //   });
  },

  methods: {

    getClicks() {
      this.loading = true;

      axios.post(`/products/buy-clicks`)
      .then((response) => {
        this.clicks = response.data;
        this.loading = false;
      });
      
    },
  },
};
</script>

<style scoped>
a.iplink {
  font-weight: normal !important;
}
.logo {
  position: relative;
  top: 0px;
}
td.agent {
  text-align: center;
  width: 70px;
}
td.source {
  text-align: center;
  width: 60px;
}
</style>